import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import ProgramService from "../../../Services/Program.service";
import { SearchButton } from "../../UI/StandardButtons/StandardButtons";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import BooleanDisplay from "../../UI/BooleanDisplay/BooleanDisplay";
import useCheckboxes from "../../Hooks/useCheckboxes";
const PAGE_SIZE = 15;
const SEARCH_DEFAULT = "";
const ACTIVE_DEFAULT = 2;
const DEFAULT_SEARCH = {
    active: ACTIVE_DEFAULT,
    search: SEARCH_DEFAULT,
};
const ProgramLookup = ({ selected: selectedPrograms, children, }) => {
    var _a, _b;
    const [search, setSearch] = React.useState(SEARCH_DEFAULT);
    const [activeSearch, setActiveSearch] = React.useState(ACTIVE_DEFAULT);
    const { getCheckbox, checkedItems } = useCheckboxes({
        externallyCheckedItems: selectedPrograms || [],
        equalsFunc: (a, b) => a.id === b.id,
    });
    const [searchArgs, setSearchArgs] = React.useState(DEFAULT_SEARCH);
    const searchItems = () => {
        setSearchArgs({
            search,
            // @ts-expect-error - TS2322 - Type 'number' is not assignable to type '0 | 1 | 2'.
            active: activeSearch,
        });
    };
    const { table, dataState } = usePagedSortedTable({
        searchArgs,
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            getCheckedItem: (data, index) => data.programs[index],
        },
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        getNumPages: (result) => TotalPageMappers.PagedInfo(result.pageInfo),
        noDataComponent: "No Programs found",
        initialSort: { sort: "name", order: "asc" },
        getData: (sort, page, sArgs) => {
            let isActive;
            switch (sArgs.active) {
                case 0:
                    isActive = false;
                    break;
                case 1:
                    isActive = true;
                    break;
                case 2:
                default:
                    isActive = null;
            }
            return ProgramService.getPrograms({
                query: sArgs.search,
                active: isActive,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                sortDirection: sort === null || sort === void 0 ? void 0 : sort.order,
            }, PAGE_SIZE, page);
        },
        columns: [
            {
                title: "Acronym",
                size: 2,
                sortId: "acronym",
            },
            { title: "Name", sortId: "name" },
            { title: "Active", sortId: "active", align: "center", size: 2 },
        ],
        rows: (data) => 
        // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'program' implicitly has an 'any' type.
        data.programs.map((program) => [
            program.acronym,
            program.name,
            _jsx(BooleanDisplay, { val: program.active }, 2),
        ]),
    });
    return children({
        lookup: (_jsxs(_Fragment, { children: [_jsxs("div", { className: "mb-3 form-inline", children: [_jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: "programSearch", className: "sr-only", children: "Search" }), _jsx("input", { type: "text", className: "form-control", id: "programSearch", placeholder: "Search Acronym, Name", style: { width: 200 }, value: search, onChange: (event) => {
                                        setSearch(event.target.value);
                                    }, onKeyPress: (e) => {
                                        if (e.key === "Enter") {
                                            searchItems();
                                        }
                                    } })] }), _jsxs("div", { className: "form-group mr-3 mt-2", children: [_jsxs("div", { className: "custom-control custom-radio custom-control-inline", children: [_jsx("input", { className: "custom-control-input", type: "radio", id: "activeTrue", value: "1", checked: activeSearch === 1, onChange: () => {
                                                setActiveSearch(1);
                                            } }), _jsx("label", { className: "custom-control-label", htmlFor: "activeTrue", children: "Active" })] }), _jsxs("div", { className: "custom-control custom-radio custom-control-inline", children: [_jsx("input", { className: "custom-control-input ", type: "radio", id: "activeFalse", checked: activeSearch === 0, onChange: () => {
                                                setActiveSearch(0);
                                            } }), _jsx("label", { className: "custom-control-label", htmlFor: "activeFalse", children: "Inactive" })] }), _jsxs("div", { className: "custom-control custom-radio custom-control-inline", children: [_jsx("input", { className: "custom-control-input", type: "radio", id: "activeBoth", checked: activeSearch === 2, onChange: () => {
                                                setActiveSearch(2);
                                            } }), _jsx("label", { className: "custom-control-label", htmlFor: "activeBoth", children: "Both" })] })] }), _jsx("div", { className: "mt-2", children: _jsx(SearchButton, { isLoading: dataState.isLoading, onClick: () => {
                                    searchItems();
                                } }) })] }), _jsx("hr", {}), table] })),
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        totalNumItems: (_b = (_a = dataState.data) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b.totalElements,
        selectedItems: checkedItems,
        isLoading: dataState.isLoading,
    });
};
export default ProgramLookup;
